import type { EconomicNexusState } from '@avalara/types/reducer-states';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: EconomicNexusState = {
  fetchedThresholds: false,
  approachingThreshold: [],
  exceedingThreshold: [],
};

type EconomicNexusPayload = { approachingThreshold: Array<string>; exceedingThreshold: Array<string> };

const store = createSlice({
  name: 'economicNexus',
  initialState,
  reducers: {
    receiveEconomicNexusThresholds: (state, action: PayloadAction<EconomicNexusPayload>) => {
      state.approachingThreshold = action.payload.approachingThreshold;
      state.exceedingThreshold = action.payload.exceedingThreshold;
      state.fetchedThresholds = true;
    },
  },
});

export const { receiveEconomicNexusThresholds } = store.actions;

export default store;
